import React, { useState, useEffect } from 'react';
import { useTypedTranslation } from '@app/hooks';

import { useSelector } from 'react-redux';
import { passwordManagerPolicyService } from '@app/services';
import { Order, IPasswordServerPolicies } from '@app/models';
import { MenuItem } from '@material-ui/core';
import { SelectInfiniteV2 } from '@app/componentsV2';
import { infiniteScrollItemsFetchLimit } from '@app/helpers';

interface IProps {
    returnPolicy: (policyId: string) => void;
}

const InitialPasswordPolicyMigrator = (props: IProps) => {
    const { translation } = useTypedTranslation();

    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    const organizationFilter = useSelector((state: any) => state.organizationSelect.selectedOrganization);
    const [policies, setPolicies] = useState<IPasswordServerPolicies[]>([]);
    const [totalCount, setTotalCount] = useState(0);
    const [selected, setSelected] = useState('');

    useEffect(() => {
        getPolicies();
    }, [organizationFilter]);

    const getPolicies = () => {
        passwordManagerPolicyService.getPolicies('DisplayName', Order.asc, 500, 0, true, handleError, handlePoliciesList, true, undefined);
    };

    const handlePoliciesList = (isReset: boolean) => (res: any) => {
        const results: IPasswordServerPolicies[] = res.data.value;

        if (results && !isReset) {
            setPolicies((previousState: any) => previousState.concat(results));
        }

        if (isReset) {
            setPolicies(results);
            setTotalCount(res.data['@odata.count']);
        }

        const defaultPolicy = results.filter(x => x.IsDefault)[0];
        setSelected(defaultPolicy?.Id);
        props.returnPolicy(defaultPolicy?.Id);
    };

    const handleError = (errorResponse: any) => {
        if (errorResponse.data.error) {
            setErrorMessage(errorResponse.data.error.message);
        } else if (errorResponse.message) {
            setErrorMessage(errorResponse.message);
        } else {
            setErrorMessage(translation('GENERIC_ERROR'));
        }
    };

    const handleChange2 = (event: any) => {
        if (event.target.value === selected) {
            return;
        }

        setSelected(event.target.value);
        props.returnPolicy(event.target.value);
    };

    const fetchMoreUsersData = (skipCount: number, currentOrgId: string, isReset: boolean) => {
        passwordManagerPolicyService.getPolicies('DisplayName', Order.asc, infiniteScrollItemsFetchLimit, skipCount, isReset, handleError, handlePoliciesList(isReset), true, undefined);
    };

    return <>
        <SelectInfiniteV2
            name='orgSelector'
            value={selected}
            onChange={handleChange2}
            id='orgSelector'
            label='ON_PREM_MIGRATOR_INITIAL_PASSWORD_POLICY'
            onFetch={fetchMoreUsersData}
            totalCount={totalCount}
            currentCount={policies.length}
        >
            {policies.map((item: any) => (
                <MenuItem key={item.Id} value={item.Id}>
                    {item.DisplayName}
                </MenuItem>
            ))}
        </SelectInfiniteV2>
        {errorMessage && <div className='modal__error'>{errorMessage}</div>}
    </>;
};

export default InitialPasswordPolicyMigrator;